import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useNostoContext } from '@srcDS/provider/nosto/NostoContext';
import { useCategoryContext } from '@srcDS/components/templates/category/context/useCategoryContext';
import { buildSearchRequest } from '@srcDS/components/organisms/categoryProductList/utils/prepareSearchRequest';

export const useNostoSearchTracking = ({ products, searchPhrase, triggerRoute }) => {
  const pathname = usePathname();
  const { nostoSearchOnChange, nostoCategoryLandOnPage, nostoSearchLandOnPage, hasNostoJs } = useNostoContext();
  const { isSearchPage, isCuratedForYou, stream } = useCategoryContext() as any;
  const merchandisedCategory = stream?.projectSpecificData?.merchandised_category;
  const productIds = products.map((product) => ({
    productId: product.productId,
  }));

  const sendNostoRecordSearch = async () => {
    const searchRequest = buildSearchRequest(searchPhrase, stream, isCuratedForYou);

    await nostoSearchOnChange({
      type: isSearchPage || isCuratedForYou ? 'serp' : 'category',
      searchRequest,
      searchResults: {
        products: productIds,
        from: stream?.from ?? searchRequest?.products?.from,
        total: stream?.total,
        count: stream?.count,
        categoryPath: merchandisedCategory ?? null,
      },
    });
  };

  useEffect(() => {
    if (!hasNostoJs) return;

    /* Category  */
    if (!isSearchPage && !isCuratedForYou) {
      if (merchandisedCategory) {
        sendNostoRecordSearch();
      }
      nostoCategoryLandOnPage(merchandisedCategory ?? stream?.projectSpecificData?.name);
    } else {
      /* Search */
      nostoSearchLandOnPage(pathname);
      sendNostoRecordSearch();
    }
  }, [isSearchPage, triggerRoute, products, pathname, stream]);
};